export default {
  props: [
    'validation',
    'data',
    'loading'
  ],

  data () {
    return {
      form: {}
    }
  },

  watch: {
    validation(errors) {
      Object.keys(errors).forEach(error => this.errors.add(error, errors[error][0]))
    },

    data(data) {
      this.form = this.data
    }
  },

  methods: {
    /**
     * Takes care of the before and after when submitting a form.
     * 
     * 1. Clears loading and current errors
     * 2. Validates the form
     * 3. Calls the callback to process form
     * 4. Puts any errors back into the form
     * 5. Clears loading state
     * 
     * @param {*} cb 
     */
    async submit() {
      this.errors.clear()

      try {
        await this.$validator.validateAll()
        this.$emit('submit', this.form)
      }
      catch (err) {
        // validator adds error messages to the form
      }

    }
  }
}